<template>
    <div
        class="flex p-6 flex-col items-start self-stretch rounded-lg bg-white shadow-md"
    >
        <div class="flex pb-8 flex-col items-start gap-1 self-stretch">
            <div class="flex items-center gap-2">
                <icon icon="headphones" />
                <h3 class="font-medium text-lg text-slate-900">
                    Consultations
                </h3>
            </div>
            <p class="text-md text-slate-500">
                Get dedicated support from our experts.
            </p>
        </div>
        <div class="flex w-160 items-start gap-16">
            <!-- First Column -->
            <div class="flex flex-col gap-4">
                <h3 class="font-medium text-md text-slate-900">
                    Free consultations
                </h3>
                <div class="flex items-center gap-2">
                    <span class="text-2xl font-bold text-slate-800">
                        {{ consultsAvailable }}
                    </span>
                    <span>/2 per year</span>
                </div>
                <div class="h-1 self-stretch rounded-full bg-slate-400"></div>
            </div>
        </div>
        <div class="flex pt-6 flex-col items-start">
            <button class="btn btn-orange !ml-0">Schedule consultation</button>
        </div>
        <div
            class="flex flex-col items-start gap-6 self-stretch bg-white rounded-lg"
        >
            <!-- Upcoming Section -->
            <div class="w-full">
                <h3 class="text-sm font-medium text-slate-800 pt-12">
                    Upcoming
                </h3>
                <!-- Paris - New York -->
                <div class="flex items-center gap-4 py-4">
                    <div
                        class="flex flex-col items-center justify-center w-12 h-12 pt-1 gap-1 rounded-md border border-slate-200 bg-[#F9FAFB] relative date-container"
                    >
                        <div
                            class="absolute top-0 w-12 h-4 rounded-t-md bg-slate-500 flex items-center justify-center"
                        >
                            <span class="text-xs text-white month">Nov</span>
                        </div>
                        <span class="absolute bottom-1 text-center day">
                            30
                        </span>
                    </div>
                    <div class="flex-grow">
                        <h4 class="text-base font-medium text-slate-800">
                            10xTravel+ 30 Minute Consultation
                        </h4>
                        <div
                            class="flex items-center gap-2 text-sm text-slate-500"
                        >
                            <span>Nov 30, 2024, 12:00 GMT -05:00</span>
                            <span
                                class="w-1 h-1 bg-slate-300 rounded-full"
                            ></span>
                            <span>Nick Smith</span>
                        </div>
                    </div>
                    <button
                        class="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-200 rounded-md hover:bg-slate-50"
                    >
                        Open invitation
                    </button>
                </div>
            </div>

            <!-- Completed Section -->
            <div class="w-full">
                <h3 class="text-sm font-medium text-slate-800">Completed</h3>
                <!-- Paris - Milan -->
                <div
                    class="flex items-center gap-4 py-4 border-b border-slate-100"
                >
                    <div
                        class="flex flex-col items-center justify-center w-12 h-12 pt-1 gap-1 rounded-md border border-slate-200 bg-[#F9FAFB] relative"
                    >
                        <div
                            class="absolute top-0 w-12 h-4 rounded-t-md bg-slate-500 flex items-center justify-center"
                        >
                            <span class="text-xs text-white">Aug</span>
                        </div>
                        <span class="absolute bottom-1 text-center">28</span>
                    </div>
                    <div class="flex-grow">
                        <div class="flex items-center gap-2">
                            <h4 class="text-base font-medium text-slate-800">
                                10xTravel+ 30 Minute Consultation
                            </h4>
                        </div>
                        <div
                            class="flex items-center gap-2 text-sm text-slate-500"
                        >
                            <span>Aug 28, 2024, 10:30 GMT -05:00</span>
                            <span
                                class="w-1 h-1 bg-slate-300 rounded-full"
                            ></span>
                            <span>John Green</span>
                        </div>
                    </div>
                </div>

                <!-- New Zealand 2023 -->
                <div
                    class="flex items-center gap-4 py-4 border-b border-slate-100"
                >
                    <div
                        class="flex flex-col items-center justify-center w-12 h-12 pt-1 gap-1 rounded-md border border-slate-200 bg-[#F9FAFB] relative"
                    >
                        <div
                            class="absolute top-0 w-12 h-4 rounded-t-md bg-slate-500 flex items-center justify-center"
                        >
                            <span class="text-xs text-white">Aug</span>
                        </div>
                        <span class="absolute bottom-1 text-center">22</span>
                    </div>
                    <div class="flex-grow">
                        <h4 class="text-base font-medium text-slate-800">
                            10xTravel+ 30 Minute Consultation
                        </h4>
                        <div
                            class="flex items-center gap-2 text-sm text-slate-500"
                        >
                            <span>Aug 18, 2024, 09:30 GMT -05:00</span>
                            <span
                                class="w-1 h-1 bg-slate-300 rounded-full"
                            ></span>
                            <span>John Green</span>
                        </div>
                    </div>
                </div>

                <!-- United Kingdom 2022 -->
                <div class="flex items-center gap-4 py-4">
                    <div
                        class="flex flex-col items-center justify-center w-12 h-12 pt-1 gap-1 rounded-md border border-slate-200 bg-[#F9FAFB] relative"
                    >
                        <div
                            class="absolute top-0 w-12 h-4 rounded-t-md bg-slate-500 flex items-center justify-center"
                        >
                            <span class="text-xs text-white">Jun</span>
                        </div>
                        <span class="absolute bottom-1 text-center">1</span>
                    </div>
                    <div class="flex-grow">
                        <h4 class="text-base font-medium text-slate-800">
                            10xTravel+ 30 Minute Consultation
                        </h4>
                        <div
                            class="flex items-center gap-2 text-sm text-slate-500"
                        >
                            <span>Jun 1, 2024, 09:30 GMT -05:00</span>
                            <span
                                class="w-1 h-1 bg-slate-300 rounded-full"
                            ></span>
                            <span>Ann Brown</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full text-left mt-2">
            <span
                class="font-medium text-sm cursor-pointer text-slate-800 hover:text-slate-900"
            >
                Show More
            </span>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useTravelPlusStore } from '@/store/travelplus';
import Icon from '@/components/ui/icon/icon.vue';

const travelPlusStore = useTravelPlusStore();

const { loadingConsultations, consultsAvailable } =
    storeToRefs(travelPlusStore);

onMounted(() => {
    travelPlusStore.getConsultations();
});
</script>
